/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-12-23",
    versionChannel: "nightly",
    buildDate: "2023-12-23T00:15:31.142Z",
    commitHash: "704bd7502e66ae26fe308250ef5065fa7989bf20",
};
